import * as classnames from 'classnames';
import * as React from 'react';

import { FlashMessageModifier } from 'models/flashMessage';

import './FlashMessage.scss';

interface FlashMessageProps {
  icon?: string;
  modifier?: FlashMessageModifier;
  text: string | JSX.Element;
}

export class FlashMessage extends React.Component<FlashMessageProps, {}> {
  render() {
    const { modifier, text } = this.props;
    const classNameModifier = modifier && 'flash-message--' + modifier;
    return (
      <div className={classnames('flash-message o-footnote-1', classNameModifier)}>
        {this.icon}
        <div className="flash-message__item">{text}</div>
      </div>
    );
  }

  get icon() {
    const { icon } = this.props;
    return icon && (
      <div className="flash-message__icon">
        <i className={classnames('flash-message__item flash-message__item--center o-icon-action', icon)}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FlashMessage/FlashMessage.tsx